import { useEffect } from "react";
import { useAuthContext } from "../context/AuthContext";
import { useSocketContext } from "../context/SocketContext";
import { buildTeamPresenceXpro4Payload } from "../utils/teamPresenceTelemetry";
import { resolvePresenceUserId } from "../utils/presenceIdentityFromAuth";

/**
 * Alinha o workspace do socket à conversa portal aberta (?ws=), para receber team_message em tempo real.
 */
export function usePortalTeamSocketWorkspace(activeWorkspace) {
  const { socket } = useSocketContext();
  const { userData, bearerToken } = useAuthContext();

  useEffect(() => {
    const slug = String(activeWorkspace || "").trim();
    if (!socket || !slug || !userData?.id) return;

    const workspace = `${slug}.xpro.me`;
    const presenceId = resolvePresenceUserId(bearerToken, userData);
    if (presenceId == null) return;
    const payload = buildTeamPresenceXpro4Payload({
      id: presenceId,
      name: userData.nome || userData.name || "",
      workspace,
    });

    socket.emit("newUser", payload);
    socket.emit("users", payload);
  }, [socket, activeWorkspace, bearerToken, userData?.id, userData?.nome, userData?.name]);
}
